import firebase from '../firebase/index';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import branch from 'recompose/branch';
import renderComponent from 'recompose/renderComponent';
import renderNothing from 'recompose/renderNothing';
import {setUser, setAuthUnconfirmed} from '../redux/actions/auth';
import LoginForm from '../components/admin/login-form/index';

const auth = firebase.auth();

function mapStateToProps(state) {
	return state.auth;
}

function mapDispatchToProps(dispatch) {
	return {
		handleAuthStateChanged(user) {
			if (user) {
				firebase.database().ref(`users/${user.uid}`)
					.once('value')
					.then(snapshot => {
						const {security: {confirmed, privileged} = {}} = snapshot.val();

						if (confirmed) {
							const userData = user.toJSON();

							userData.privileged = privileged;
							dispatch(setUser(userData));
						} else {
							dispatch(setAuthUnconfirmed());
							firebase.auth().signOut();
						}
					});
			} else {
				dispatch(setUser(null));
			}
		}
	};
}

let unsubscribe = null;

export default compose(
	connect(mapStateToProps, mapDispatchToProps),
	lifecycle({
		componentDidMount() {
			unsubscribe = auth.onAuthStateChanged(this.props.handleAuthStateChanged);
		},
		componentWillUnmount() {
			if (unsubscribe) {
				unsubscribe();
				unsubscribe = null;
			}
		}
	}),
	branch(
		props => props.authWait,
		renderNothing
	),
	branch(
		props => !props.user,
		renderComponent(LoginForm)
	)
);



// WEBPACK FOOTER //
// ./src/client/routes/with-check-auth.js